<template>
    <div class="mentoring-container">
        <!-- Módulos da Mentoria -->
        <div class="modules-section">
            <div class="section-header">
                <h3><i class="fas fa-graduation-cap"></i> Módulos da Mentoria</h3>
                <p>Progresso detalhado por módulo e atividades</p>
            </div>
            <ListModules :modules="sections" @view-activity="openActivityModal" />
        </div>
    </div>
</template>

<script>

import http from '@/http'
import ListModules from "@/views/mentee/list-modules.vue";

export default {
    components: {
        ListModules,
    },
    data() {
        return {
            sections: [],
            mentee: this.$route.params.mentee,
            slug: this.$route.params.slug,
            completed: 0,
            total: 1,
        }
    },

    methods: {
        async getData() {

            const mentee = this.$route.params.mentee;
            const mentoring = this.$route.params.mentoring;

            const formData = {
                mentee,
                id: mentoring
            }
            http.post('mentorings/tasks-by-mentee/', formData)
                .then(response => {
                    this.sections = response.data.mentoring.sections;
                    this.sections.progress = response.data.progress;
                    this.$store.commit('mentee/setTasks', {
                        sections: this.sections,
                        mentoring,
                        mentee
                    });
                })
                .catch(e => {
                    console.error('Get Tasks Mentoring: ', e)
                })
        },

        openActivityModal(activity) {
            this.$emit('view-activity', activity);
        }
    },

    mounted() {
        this.getData();
    }
}

</script>

<style scoped>
/* Container Principal */
.mentoring-container {
    background: white;
    border-radius: 20px;
    padding: 2rem;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    border: 1px solid rgba(0,0,0,0.05);
}

/* Seção de Módulos */
.modules-section {
    margin-top: 0;
}

.section-header {
    margin-bottom: 2rem;
    text-align: center;
}

.section-header h3 {
    font-size: 1.75rem;
    font-weight: 700;
    color: #2c3e50;
    margin: 0 0 0.5rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
}

.section-header h3 i {
    color: #667eea;
}

.section-header p {
    color: #7f8c8d;
    margin: 0;
    font-size: 1rem;
}

/* Responsividade */
@media (max-width: 768px) {
    .mentoring-container {
        padding: 1.5rem;
    }
    
    .section-header h3 {
        font-size: 1.5rem;
    }
}

@media (max-width: 576px) {
    .mentoring-container {
        padding: 1rem;
        border-radius: 15px;
    }
}

/* Animações */
@keyframes slideInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.modules-section {
    animation: slideInUp 0.6s ease-out;
}
</style>
